import { Col, Container, Row } from 'react-bootstrap'
import laoApp from 'assets/images/footer-laoapp.svg'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { getSettingQuery } from 'dataLayer/user'
import { getAllGameQuery } from 'dataLayer/game'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setTypeLinkFooter } from 'store/actions'
import { logDOM } from '@testing-library/react'
import { PATHS } from 'config/routes'

function Footer() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { data: helpData } = useQuery(getSettingQuery())
	const { data: games } = useQuery(getAllGameQuery())
	const gameIsHot = games?.filter(item => item?.is_hot === 1)
	let listHelpData = []
	helpData &&
		helpData.map(it => {
			switch (it.type) {
				// case 'term-condition':
				// 	it = { ...it, name: t('footer.term_condition') }
				// 	listHelpData.push(it)
				// 	break
				// case 'intro':
				// 	it = { ...it, name: t('footer.intro') }
				// 	listHelpData.push(it)
				// 	break
				case 'contact':
					it = { ...it, name: t('footer.contact') }
					listHelpData.push(it)
					break
				// case 'term-privacy':
				// 	it = { ...it, name: t('footer.receive') }
				// 	listHelpData.push(it)
				// 	break
				// case 'summary':
				// 	it = { ...it, name: t('footer.summary') }
				// 	listHelpData.push(it)
				// 	break
				case 'faq':
					it = { ...it, name: t('footer.faq') }
					listHelpData.push(it)
					break
				default:
					break
			}
		})
	return (
		<Container className="footer-menu" fluid>
			<Row className="justify-content-center">
				<Col md={6} xl={5} className="footer-title">
					<img src={laoApp} alt="Footer logo" />
					<p>{t('footer.all_right')}</p>
					<p>{t('footer.content')}</p>
				</Col>
				<Col md={3} xl={3}>
					<h2>{t('footer.hot')}</h2>
					<ul>
						{gameIsHot &&
							gameIsHot.map((it, index) => (
								<li key={index}>
									<Link
										// to={PATHS.ROOM_PAGE.replace(':roomId', it?.id)}
										to={
											it?.id === 1 ?
												process.env.REACT_APP_LINK_WEB_MINERGOLD :
												it?.id === 2 ? process.env.REACT_APP_LINK_WEB_KNIFE :
													process.env.REACT_APP_LINK_WEB_BEATMOUSE
										}
										target="_blank"
									>
										{it.name}
									</Link>
								</li>
							))}
					</ul>
				</Col>
				<Col md={3} xl={3}>
					<h2>{t('footer.help')}</h2>
					<ul className="footer-help">
						{listHelpData &&
							listHelpData?.map((it, index) => (
								<li key={index}>
									<Link to={PATHS.SETTING_PAGE.replace(':type', it?.type)}>
										{it.name}
									</Link>
								</li>
							))}
					</ul>
				</Col>
			</Row>
		</Container>
	)
}

export default Footer
